// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2W3rO","requiredAsterisk":"Info_requiredAsterisk__23Isi"};